import { getPhotographer, getAllMediasForPhotographer } from "../../../app/lib/prisma-db";
import PhotographerHeader from "./components/PhotographerHeader/PhotographerHeader";
import PhotographerMedias from "./components/PhotographerMedias/PhotographerMedias";

/**
 * Photographer page component
 *
 * This is the main page for a single photographer.
 * It fetches the photographer's data and their media,
 * then renders the header and media gallery.
 *
 * Props:
 * - params: { slug: string } from the URL, e.g., "243-mimi-keel"
 */
export default async function Page({ params }) {
    // Extract the slug from the URL parameters
    const { slug } = await params;

    // Extract the photographer ID from the slug (before the first dash)
    const id = parseInt(slug.split("-")[0]);

    // Fetch photographer details from the database
    const photographer = await getPhotographer(id);

    // Fetch all media for this photographer from the database
    const medias = await getAllMediasForPhotographer(id);

    return (
        <>
            {/* Photographer header: name, location, tagline, portrait, contact button */}
            <PhotographerHeader 
                photographer={photographer}
            />

            {/* Photographer media gallery: images/videos with likes, sorting, and modal */}
            <PhotographerMedias
                photographer={photographer}
                medias={medias}
            />
        </>
    );
}
